import { toast } from 'react-toastify';

import { forEach, find as findLodash } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';
import moment from 'moment';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestData({ payload }) {
  try {
    const { params } = payload;
    const wherefield = [...params.wherefield];
    const valuewherefield = [...params.valuewherefield];
    const typewherefield = [...params.typewherefield];

    forEach(wherefield, (where, index) => {
      if (where === 'data_cadastro_ini') {
        wherefield[index] = 'aupa_data_evento'
      } else if (where === 'data_cadastro_fim') {
        wherefield[index] = 'aupa_data_evento_fim'
      }
    });

    const modParams = {
      ...params,
      wherefield,
      valuewherefield,
      typewherefield,
    };

    const response = yield call(api.get, 'auditoriaparametros', {
      params: modParams,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteData({ payload }) {
  try {
    const { id, params } = payload;

    yield call(api.delete, `auditoriaparametros/${id}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.post, 'auditoriaparametros', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/auditoriaparametros');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `auditoriaparametros/${id}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'auditoriaparametros', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/auditoriaparametros');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const wherefield = [...params.wherefield];
    const valuewherefield = [...params.valuewherefield];
    const typewherefield = [...params.typewherefield];

    forEach(wherefield, (where, index) => {
      if (where === 'aupa_data_evento') {
        const isTime = moment(valuewherefield[index], 'DD/MM/YYYY HH:mm:ss');

        valuewherefield[index] = isTime
          .clone()
          .set({ hour: 0, minute: 0, second: 0 })
          .format('DD/MM/YYYY HH:mm:ss');

        if (!findLodash(wherefield, (w) => w === 'aupa_data_evento_fim')) {
          wherefield.push('aupa_data_evento_fim');
          valuewherefield.push(
            isTime
              .clone()
              .set({ hour: 23, minute: 59, second: 59 })
              .format('DD/MM/YYYY HH:mm:ss')
          );
          typewherefield.push('MENOR_IGUAL');
        }
      }
    });

    const modParams = {
      ...params,
      wherefield,
      valuewherefield,
      typewherefield,
    };

    const response = yield call(api.get, 'auditoriaparametros', {
      params: modParams,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@auditoriaParametros/DATA_IN_REQUEST', requestData),
  takeLatest('@auditoriaParametros/DELETE_DATA', deleteData),
  takeLatest('@auditoriaParametros/SUCCESS_REMOVE', requestData),
  takeLatest('@auditoriaParametros/STORE_DATA', store),
  takeLatest('@auditoriaParametros/FIND_DATA', find),
  takeLatest('@auditoriaParametros/UPDATE_DATA', update),
  takeLatest('@auditoriaParametros/RECORD_FILTERING', applyedFilters),
]);
